import { ErrorLoad, MessageWrap, Paginator, StepCSSTransitionGroup, Table, TableBody } from "@wg/wows-react-uikit";
import { Tooltip } from "components";
import { getMemberTooltipContent } from "helpers/tooltip";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import PropTypes from "prop-types";
import * as React from "react";
import { translate } from "react-i18next";
import settings from "settings";
import { ClanIsDisbandedTooltip, ClanMembersInfoMissingTooltip, MemberInfoMissingTooltip, MemberIsBannedTooltip, RankTooltipContent } from "tooltips";
import ApplicationsNonClanMemberTableItem from "../../Requests/ApplicationsNonClanMemberTableItem";
import InvitesClanMemberTableItem from "../../Requests/InvitesClanMemberTableItem";
import { EntriesTableHead } from "../UIKit";

const propTypes = {
  entryType: PropTypes.oneOf(['invites', 'applications']),
  headers: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    isSortable: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    modify: PropTypes.string.isRequired,
    glyph: PropTypes.string
  })).isRequired,
  currentAccount: PropTypes.shape({
    id: PropTypes.number.isRequired,
    clanId: PropTypes.number
  }).isRequired,
  isCurrentClanFull: PropTypes.bool,
  root: PropTypes.string.isRequired,
  entries: PropTypes.shape({
    sort: PropTypes.shape({
      order: PropTypes.string.isRequired,
      isAsc: PropTypes.bool.isRequired
    }).isRequired,
    isFetching: PropTypes.bool.isRequired,
    invites: PropTypes.array,
    applications: PropTypes.array,
    page: PropTypes.number.isRequired,
    meta: PropTypes.object,
    error: PropTypes.object
  }).isRequired,

  t: PropTypes.func.isRequired,
  fetchEntriesByCurrentState: PropTypes.func.isRequired,
  onBattleTypeChange: PropTypes.func.isRequired,
  onReloadClick: PropTypes.func.isRequired,
  sendApplication: PropTypes.func,
  onSendInvite: PropTypes.func,

  fetchEntriesByPage: PropTypes.func.isRequired,
  onSortClick: PropTypes.func.isRequired,

  openAccountProfile: PropTypes.func,
  openChatWindow: PropTypes.func

};

class NonOperationalEntries extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      fetchByNewPage: false
    };

    this.app = document.getElementById('app');
    this.getMemberTooltipContent = this.getMemberTooltipContent.bind(this);
    this.getRankTooltipContent = this.getRankTooltipContent.bind(this);
  }

  componentDidMount() {
    this.props.fetchEntriesByCurrentState(this.withGlobalSpinner());
    this.app.scrollTop = 0;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {// eslint-disable-line
    this.setState({ fetchByNewPage: this.props.entries.page !== nextProps.entries.page });
  }

  UNSAFE_componentWillUpdate(nextProps) {// eslint-disable-line
    const isScrollAfterLocalFetching = (this.props.entries.isFetching && !nextProps.entries.isFetching && isNull(this.props.entries.error));
    if (isScrollAfterLocalFetching) {
      this.app.scrollTop = 0;
    }
  }

  renderError() {
    const {
      t,
      entryType
    } = this.props;
    const message = entryType === 'invites' ? t('Не удалось получить информацию по приглашениям.') : t('Не удалось получить информацию по заявкам.');

    return <ErrorLoad message={message} onReloadClick={this.props.onReloadClick} t={t} />;
  }

  renderEntries() {
    const {
      entryType
    } = this.props;
    const entries = this.props.entries[entryType];
    let entriesList = null;

    if (entryType === 'invites') {
      entriesList = entries.map(invite => <InvitesClanMemberTableItem key={invite.id} invite={invite} isCurrentClanFull={this.props.isCurrentClanFull} openAccountProfile={this.props.openAccountProfile} openChatWindow={this.props.openChatWindow} onSendInvite={this.props.onSendInvite} hasActiveInviteForAccount={invite.status === 'active' || entries.some(item => item.account.id === invite.account.id && item.status === 'active')} />);
    } else {
      entriesList = entries.map(application => <ApplicationsNonClanMemberTableItem key={application.id} application={application} currentAccount={this.props.currentAccount} sendApplication={this.props.sendApplication} hasActiveApplicationForClan={application.status === 'active' || entries.some(item => item.clan.id === application.clan.id && item.status === 'active')} root={this.props.root} />);
    }

    return <TableBody>
      {entriesList}
    </TableBody>;
  }

  renderPaginator() {
    if (this.props.entries.meta) {
      return <Paginator key="paginator" page={this.props.entries.page} total={this.props.entries.meta.total} limit={settings.entries.limit} isFetching={this.state.fetchByNewPage} isDisabled={this.props.entries.isFetching} onSelectedPage={this.props.fetchEntriesByPage} />;
    }

    return null;
  }

  isGlobalFetching() {
    return this.props.entries.isFetching;
  }

  withGlobalSpinner() {
    return (isNull(this.props.entries.error) && isEmpty(this.props.entries[this.props.entryType]) && isEmpty(this.props.entries.meta));
  }

  getMemberTooltipContent(tooltipTip) {
    if (!tooltipTip) return null;

    const memberId = Number(tooltipTip);
    const members = {};
    this.props.entries[this.props.entryType].forEach(entry => {
      return members[entry.account.id] = entry.account;
    });

    return getMemberTooltipContent(members[memberId], this.props.currentAccount, true);
  }

  getRankTooltipContent(tooltipTip) {
    if (!tooltipTip) return null;

    const memberId = Number(tooltipTip);
    const entries = this.props.entries[this.props.entryType];
    const entry = entries.find(entry => entry.account.id === memberId);

    return <RankTooltipContent rank={entry.statistics.rank} seasonId={entry.statistics.season_id} seasonRank={entry.statistics.season_rank} />;
  }

  render() {
    if (this.isGlobalFetching()) return null;

    const {
      t,
      entryType
    } = this.props;
    const total = get(this.props, 'entries.meta.total', 0);
    const isErrored = !isNull(this.props.entries.error);

    if (total === 0 && !isErrored && !this.props.entries.isFetching) {
      let title = t('Нет отправленных заявок');
      let message = t('Последние 28 дней вы не отправляли заявки на вступление в клан.');

      if (entryType === 'invites') {
        title = t('Нет отправленных приглашений');
        message = t('Последние 28 дней ваш клан не отправлял приглашения игрокам.');
      }

      return <StepCSSTransitionGroup level={1}>
        <MessageWrap title={title} message={message} key="nonoperational-message-empty" />
      </StepCSSTransitionGroup>;
    }

    return <StepCSSTransitionGroup level={1}>
      <Table key="table" isFetching={this.props.entries.isFetching} isErrored={isErrored} stickyContainerId="non-operational-entries-sticky-container">
        <EntriesTableHead sort={this.props.entries.sort} headers={this.props.headers} stickyContainerId="non-operational-entries-sticky-container" onSortClick={this.props.onSortClick} />
        {isErrored ? this.renderError() : this.renderEntries()}
      </Table>
      {this.renderPaginator()}

      <ClanIsDisbandedTooltip />
      <ClanMembersInfoMissingTooltip />
      <MemberIsBannedTooltip />
      <MemberInfoMissingTooltip />
      <Tooltip id="member-tooltip" getContent={this.getMemberTooltipContent} />
      <Tooltip id="rank-tooltip" getContent={this.getRankTooltipContent} />

    </StepCSSTransitionGroup>;
  }
}

NonOperationalEntries.propTypes = propTypes;

export default translate()(NonOperationalEntries);